(() => {
  const galleries = document.querySelectorAll('[data-gameday-field-gallery]');

  galleries.forEach((gallery) => {
    const image = gallery.querySelector('[data-gameday-field-gallery-image]');
    const caption = gallery.querySelector('[data-gameday-field-gallery-caption]');
    const count = gallery.querySelector('[data-gameday-field-gallery-count]');
    const previous = gallery.querySelector('[data-gameday-field-gallery-previous]');
    const next = gallery.querySelector('[data-gameday-field-gallery-next]');
    const thumbs = Array.from(gallery.querySelectorAll('[data-gameday-field-gallery-thumb]'));

    if (!image || !caption || !count || thumbs.length === 0) return;

    let activeIndex = Math.max(0, thumbs.findIndex((thumb) => thumb.classList.contains('is-active')));

    const show = (index) => {
      activeIndex = (index + thumbs.length) % thumbs.length;
      const active = thumbs[activeIndex];

      image.src = active.dataset.src;
      image.alt = active.dataset.alt || '';
      caption.textContent = active.dataset.caption || '';
      count.textContent = `${String(activeIndex + 1).padStart(2, '0')} / ${String(thumbs.length).padStart(2, '0')}`;

      thumbs.forEach((thumb, thumbIndex) => {
        const isActive = thumbIndex === activeIndex;
        thumb.classList.toggle('is-active', isActive);
        thumb.setAttribute('aria-pressed', String(isActive));
      });

      active.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'nearest' });
    };

    thumbs.forEach((thumb, index) => thumb.addEventListener('click', () => show(index)));
    previous?.addEventListener('click', () => show(activeIndex - 1));
    next?.addEventListener('click', () => show(activeIndex + 1));

    gallery.addEventListener('keydown', (event) => {
      if (event.key === 'ArrowLeft') {
        event.preventDefault();
        show(activeIndex - 1);
      }
      if (event.key === 'ArrowRight') {
        event.preventDefault();
        show(activeIndex + 1);
      }
    });
  });
})();
